module.exports = __webpack_public_path__ + "images/sales-share-nav-icon-a6a9bf94.svg";